module.exports = __webpack_public_path__ + "add dental booking.svg?2d11b1ef317f7bd6f02fccc320539d05";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/add dental booking.svg
// module id = 350
// module chunks = 0